<div *ngIf="reportType === 'VeryBriefly-Officer'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================================================= -->
    <!-- ===== OVERALL REPORT HEADER (FIRST PAGE ONLY) ==== -->
    <!-- ================================================= -->
    <div class="report-header">

      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <th colspan="3" class="overall-header"style="text-align:center;font-size:18px;">
            हिंदुस्तान प्रकाशन संस्था
          </th>
          <th colspan="4" class="overall-header"style="text-align:center;font-size:18px;">
            Book Registration Ledger Report
          </th>
          <th colspan="2" class="overall-header text-end"style="text-align:center;font-size:18px;">
           दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>

        <tr>
          <th colspan="3" class="overall-header"style="text-align:center;font-size:18px;">
            विवेक पुस्तक प्रकाशन
          </th>
          <th colspan="4" class="overall-header"style="text-align:center;font-size:18px;">
            Office Representative Bookwise
          </th>
          <th colspan="2" class="overall-header text-end"style="text-align:center;font-size:18px;">
            Date : From {{ startDate | date:'dd-MM-yyyy' }}
            To {{ endDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>
      </table>

    </div>

    <!-- =============================================== -->
    <!-- ================= DATA TABLE ================= -->
    <!-- =============================================== -->
    <table >

      <!-- ===== TABLE HEADER (REPEATS EVERY PAGE) ===== -->
      <thead >

        <tr>
          <th style="width:4%">Sr</th>
          <th style="width:50%">Office Representative</th>
          <th style="width:8%" class="text-end">Sale<br>Copies</th>
          <th style="width:8%" class="text-end">Return<br>Copies</th>
          <th style="width:8%" class="text-end">Comp<br>Copies</th>
          <th style="width:12%" class="text-end">Total Amt</th>
          <th style="width:12%" class="text-end">Receipt Amt</th>
          <th style="width:12%" class="text-end">Credit Amt</th>
          <th style="width:8%" class="text-end">Pending Amt</th>
          <th style="width:8%" class="text-end">Commission</th>
        </tr>

      </thead>

      <!-- ================= TABLE BODY ================= -->
      <tbody>

        <ng-container *ngFor="let group of groupedData">

          <!-- BOOK NAME -->
          <tr class="book-row">
            <td colspan="10">
              <strong>Book Name : {{ group.book_name }}</strong>
            </td>
          </tr>

          <!-- OFFICE REP ROWS -->
          <tr *ngFor="let row of group.office_reps; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td>{{ row.office_rep_name }}</td>
            <td class="text-end">{{ row.sale_copies }}</td>
             <td class="text-end">{{ row.return_copies }}</td>
            <td class="text-end">{{ row.complimentary_copies }}</td>
            <td class="text-end">{{ row.final_total_amount }}</td>
            <td class="text-end">{{ row.received_amt  }}</td>
            <td class="text-end">{{ row.credit_amt  }}</td>
            <td class="text-end">{{ row.remaining_amt  }}</td>
            <td class="text-end">{{ row.rep_commission_amt  }}</td>
          </tr>

          <!-- BOOK TOTAL -->
          <tr class="book-total">
            <td colspan="2" class="text-end"><strong>Book Total</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.sale_copies }}</strong></td>
 <td class="text-end"><strong>{{ group.book_totals.return_copies }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.complimentary_copies }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.total_amount }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.received_amt  }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.credit_amt  }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.remaining_amt  }}</strong></td>
            <td class="text-end"><strong>{{ group.book_totals.rep_commission_amt  }}</strong></td>
          </tr>

        </ng-container>

        <!-- GRAND TOTAL -->
        <tr class="grand-total">
          <td colspan="2" class="text-end" style="background:#c8753f;font-weight:bold;"><strong>Grand Total</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandSaleCopies }}</strong></td>
            <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandReturnCopies }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandCompCopies }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandAmount  }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandReceived  }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandCredit }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandRemaining  }}</strong></td>
          <td class="text-end" style="background:#c8753f;font-weight:bold;"><strong>{{ grandCommission  }}</strong></td>
        </tr>

      </tbody>
    </table>

    <!-- ACTION BUTTONS -->
    <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4">
      <button class="btn btn-primary" (click)="exportExcel('Booking_InDetail_Bookwise')">Export</button>
      <button class="btn btn-primary" (click)="printPage()">Print</button>
      <button class="btn btn-secondary" mat-dialog-close>Close</button>
    </div>

  </div>
</div>
